module.exports = __webpack_public_path__ + "static/media/offline.cb9e9f06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/offline.svg
// module id = 587
// module chunks = 0